import { renderMessage } from "./renderMessage";
import { handleAjaxError } from "./handleAjaxError";
import { updateCredits } from "./updateCredits";
import { messageQueue } from "./messageQueue";
import { messageResponseEvent } from "../events/messageResponseEvent";

export function shareImage() {
    jQuery(document).ready(function ($) {

        $('.g-chatform-share-image').click(function () {
            /**
             * Analytics
             */
            if (typeof growtypeAnalyticsCapture === 'function') {
                growtypeAnalyticsCapture('growtype_analytics_growtype_chat_action_clicked', {
                    title: 'share_image'
                });
            }
        });

        $('.g-chatform-share-image .shareImageInput').on('change', function () {
            let fileInput = this;
            let mainBtn = $(this).closest('.g-chatform-share-image');

            if (fileInput.files && fileInput.files[0]) {
                mainBtn.addClass('is-loading');

                let chatForm = $(this).closest('.g-chatform');
                let chatId = chatForm.attr('id');
                let sessionToken = chatForm.attr('data-session-token');
                let userToken = chatForm.attr('data-user-token');
                let formData = new FormData();
                formData.append('image', fileInput.files[0]);
                formData.append('action', 'growtype_chat_share_image');
                formData.append('nonce', growtype_chat_ajax.nonce);

                formData.append('session', JSON.stringify({
                    token: sessionToken,
                    url: window.location.href,
                    bot_profile: window.growtype_chat[chatId]['bot_profile'],
                }));

                formData.append('user', JSON.stringify({
                    token: userToken,
                }));

                $.ajax({
                    url: growtype_chat_ajax.url,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        messageQueue.addToQueue(async () => {
                            /**
                             * Update credits
                             */
                            updateCredits(response.data.existing_credits);

                            /**
                             * Dispatch event
                             */
                            document.dispatchEvent(messageResponseEvent({
                                'response': response,
                            }));

                            await renderMessage(chatForm, response);
                        });

                        mainBtn.removeClass('is-loading');

                        fileInput.value = "";
                    },
                    error: function (response) {
                        handleAjaxError(response, mainBtn);

                        fileInput.value = "";
                    }
                });
            }
        });
    });
}
